import React from 'react';

/*
	svg instead of div
	https://stackoverflow.com/questions/17441810/pointer-events-none-does-not-work-in-ie9-and-ie10
*/
const SelectionOverlay = ({ top = 0, left = 0, width = 0, height = 0 }) =>
	<svg
		style={{
			position: 'absolute',
			top,
			left,
			width,
			height,
			pointerEvents: 'none'
		}}
	>
		<rect
			width="100%"
			height="100%"
			style={{ fill: 'rgba(100, 178, 183, 0.2)' }}
		/>
	</svg>;

export default SelectionOverlay;



// WEBPACK FOOTER //
// ./src/js/PatternDuplication/SelectionOverlay.js